// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionFeaturedListings_title__21S1V","listings":"SectionFeaturedListings_listings__1jiUr","listingCard":"SectionFeaturedListings_listingCard__28Z4a"};